import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM21 3H3v6h2V5h14v14H5v-4H3v6h18V3z"
}), 'ExitToAppSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExitToAppSharp.js
// module id = 3436
// module chunks = 2